var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceOrderAlHalal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.2,60.9a34.27,34.27,0,1,1-39-28.7A34.22,34.22,0,0,1,184.2,60.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,62.12a26.12,26.12,0,1,1-29.71-21.87A26.09,26.09,0,0,1,176.14,62.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,61.31c-.15,0-.43-1.09-1.15-3a27.72,27.72,0,0,0-4.17-7.47,26.56,26.56,0,0,0-4.13-4.17,25.63,25.63,0,0,0-5.72-3.5,25.82,25.82,0,0,0-7.11-2,25.23,25.23,0,0,0-3.91-.2,26.35,26.35,0,0,0-4,.41,27.43,27.43,0,0,0-3.89,1A24.57,24.57,0,0,0,138.34,44a23.05,23.05,0,0,0-3.19,2,24.34,24.34,0,0,0-2.75,2.36,26.27,26.27,0,0,0-4.12,5.3A27.31,27.31,0,0,0,125.9,59a27.6,27.6,0,0,0-1.25,8.46c0,2,.14,3.18,0,3.21s-.51-1.08-.77-3.17a24.12,24.12,0,0,1,.67-8.89,26.37,26.37,0,0,1,6.54-11.57,26.93,26.93,0,0,1,6.32-4.82,26.25,26.25,0,0,1,3.85-1.73,27.92,27.92,0,0,1,4.2-1.13,29.13,29.13,0,0,1,4.33-.43,26.61,26.61,0,0,1,4.21.25,25.32,25.32,0,0,1,4,.88,24.73,24.73,0,0,1,3.64,1.4A26.25,26.25,0,0,1,171.83,50a24.43,24.43,0,0,1,3.78,8.08C176.11,60.12,176.13,61.29,176,61.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.56,81l.74,4.49-4,.66-.73-4.36c-4,.41-8-.2-10.5-1.56L142.46,75a16.4,16.4,0,0,0,8.25,1.56l-1.11-6.69c-4.63-.35-9.84-1-10.79-6.74-.7-4.25,1.78-8.4,8-10.17l-.74-4.45,4-.66.72,4.36a18.44,18.44,0,0,1,8.54,1.1l-1.19,5.26a16.68,16.68,0,0,0-6.47-1.07l1.13,6.82c4.61.3,9.75,1,10.68,6.62C164.17,75.06,161.73,79.17,155.56,81Zm-6.94-17-.94-5.69c-2,.83-2.69,2.13-2.47,3.45S146.77,63.66,148.62,63.93Zm8.49,8.51c-.23-1.4-1.52-2-3.34-2.29l.92,5.53C156.62,74.91,157.33,73.73,157.11,72.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.65,246.8a21,21,0,1,1-23.92-17.61A21,21,0,0,1,389.65,246.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,247.54a16,16,0,1,1-18.23-13.42A16,16,0,0,1,384.7,247.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,247.05a9.59,9.59,0,0,1-.7-1.84,17.45,17.45,0,0,0-2.56-4.59,17,17,0,0,0-2.54-2.56,16,16,0,0,0-3.51-2.15,15.72,15.72,0,0,0-4.36-1.23,16.13,16.13,0,0,0-4.86.13,17.12,17.12,0,0,0-2.39.63,16.11,16.11,0,0,0-2.2,1,15.51,15.51,0,0,0-2,1.24,16,16,0,0,0-1.69,1.46,16,16,0,0,0-4,6.54,17,17,0,0,0-.77,5.19,8.8,8.8,0,0,1,0,2,4.82,4.82,0,0,1-.47-1.95,14.89,14.89,0,0,1,.41-5.46,16.89,16.89,0,0,1,1.41-3.55,16.74,16.74,0,0,1,4.39-5.14,16.09,16.09,0,0,1,2.1-1.36,15.31,15.31,0,0,1,2.36-1.07,18.11,18.11,0,0,1,2.58-.69,17.11,17.11,0,0,1,2.65-.26,15.82,15.82,0,0,1,2.59.15,16,16,0,0,1,2.44.54,15.62,15.62,0,0,1,2.23.86,16,16,0,0,1,6.27,5.21,14.8,14.8,0,0,1,2.32,5A4.72,4.72,0,0,1,384.62,247.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,259.11l.46,2.76-2.46.41-.45-2.68a11.77,11.77,0,0,1-6.44-1l.85-3.22a10,10,0,0,0,5.06,1l-.68-4.1c-2.84-.21-6-.62-6.62-4.14-.43-2.6,1.09-5.15,4.9-6.24l-.45-2.73,2.46-.41.44,2.68a11.32,11.32,0,0,1,5.24.68l-.72,3.23a10.08,10.08,0,0,0-4-.66l.69,4.18c2.84.19,6,.6,6.56,4.07C377.36,255.49,375.85,258,372.07,259.11Zm-4.26-10.46-.58-3.49c-1.25.51-1.65,1.31-1.51,2.12S366.67,248.49,367.81,248.65Zm5.21,5.23c-.14-.86-.93-1.21-2-1.41l.56,3.4C372.72,255.39,373.15,254.67,373,253.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.56,267.33a28.53,28.53,0,1,1-32.46-23.9A28.51,28.51,0,0,1,92.56,267.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.85,268.34a21.74,21.74,0,1,1-24.74-18.21A21.73,21.73,0,0,1,85.85,268.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,267.66a12.79,12.79,0,0,1-1-2.5A23.15,23.15,0,0,0,81.31,259a22.07,22.07,0,0,0-3.44-3.48,21.68,21.68,0,0,0-4.76-2.91,19.92,19.92,0,0,0-2.84-1,21,21,0,0,0-6.34-.81,22.25,22.25,0,0,0-3.33.34,21.3,21.3,0,0,0-6.23,2.17,21.39,21.39,0,0,0-4.95,3.66,21.63,21.63,0,0,0-5.4,8.88,23,23,0,0,0-1.05,7,12.75,12.75,0,0,1,0,2.68,6.56,6.56,0,0,1-.63-2.64,20,20,0,0,1,.56-7.4,21.59,21.59,0,0,1,5.44-9.63,22.32,22.32,0,0,1,5.26-4,21.64,21.64,0,0,1,3.21-1.44,22.28,22.28,0,0,1,7.1-1.3,22.67,22.67,0,0,1,3.51.21,22.11,22.11,0,0,1,3.31.73,22.38,22.38,0,0,1,3,1.17,22,22,0,0,1,5,3.24,22.64,22.64,0,0,1,3.49,3.83A20.11,20.11,0,0,1,85.4,265,6.5,6.5,0,0,1,85.74,267.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,284l.62,3.74-3.34.55-.6-3.63a16.12,16.12,0,0,1-8.75-1.3L57.8,279a13.74,13.74,0,0,0,6.87,1.3l-.92-5.58c-3.86-.28-8.2-.83-9-5.6-.58-3.54,1.48-7,6.66-8.47L60.8,257l3.34-.55.6,3.64a15.27,15.27,0,0,1,7.11.91l-1,4.38a14,14,0,0,0-5.39-.89l.94,5.67c3.84.26,8.12.82,8.9,5.52C75.88,279.11,73.84,282.53,68.71,284Zm-5.78-14.19-.78-4.74c-1.7.7-2.24,1.78-2.06,2.88S61.39,269.62,62.93,269.84ZM70,276.93c-.19-1.17-1.26-1.64-2.78-1.9l.76,4.6C69.59,279,70.18,278,70,276.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.88,197.14,254.66,142.91a8.5,8.5,0,0,1-5.59-10.63L282.58,24.66a8.49,8.49,0,0,1,10.62-5.59L467.43,73.31A8.49,8.49,0,0,1,473,83.93l-33.5,107.63A8.5,8.5,0,0,1,428.88,197.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,101,274,111.6l-1.08-.34,3-9.6-2.5-.78.31-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,114l-.31,1-7.41-2.31.24-.77,5.73-2.94c1.56-.8,2-1.44,2.24-2.17.38-1.22-.25-2.24-1.86-2.75a3.81,3.81,0,0,0-3.26.28l-.56-.9a5,5,0,0,1,4.22-.35c2.14.67,3.16,2.18,2.61,4-.31,1-.91,1.82-2.76,2.77l-4.7,2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,115.67l-2.12-.66-.86,2.78-1.09-.34.87-2.77-6-1.86L288,112l7.78-5.26,1.21.38-7.53,5.14,4.59,1.43.76-2.45,1.06.33-.77,2.45,2.12.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,120.72l-2.11-.66-.87,2.78L309,122.5l.87-2.78-6-1.86.25-.78,7.78-5.27,1.21.38-7.53,5.14,4.59,1.43.76-2.44,1.06.32-.76,2.45,2.11.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.42,123.26c-.56,1.8-2.25,2.81-4.83,2a5.76,5.76,0,0,1-3.37-2.54l.8-.7a4.8,4.8,0,0,0,2.86,2.23c1.8.56,3,0,3.43-1.3s-.17-2.47-2.85-3.3l-2.25-.7,2.19-5.14,5.79,1.8-.31,1-4.83-1.5-1.41,3.25,1.36.42C322.19,119.76,323,121.39,322.42,123.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.89,126.47c-.62,2-2.57,2.76-4.63,2.12-2.8-.87-3.72-3.3-2.68-6.64,1.11-3.59,3.66-4.85,6.53-4a5.1,5.1,0,0,1,2.33,1.36l-.71.74a3.82,3.82,0,0,0-1.9-1.14c-2.28-.71-4.2.3-5.1,3.17-.07.24-.15.55-.22.87a3.53,3.53,0,0,1,3.8-.8C332.41,122.84,333.49,124.53,332.89,126.47Zm-1.09-.31c.44-1.39-.31-2.6-1.95-3.11a2.56,2.56,0,0,0-3.43,1.47c-.36,1.16.26,2.56,2.09,3.13A2.41,2.41,0,0,0,331.8,126.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.31,131.09c-.55,1.77-2.26,2.73-4.81,1.93a5.77,5.77,0,0,1-3.38-2.54l.8-.7a4.8,4.8,0,0,0,2.89,2.24c1.75.55,3,0,3.38-1.28s-.23-2.38-2.2-3l-.75-.23.25-.8,4.07-2.76-5.41-1.68.3-1,6.8,2.12-.24.77L344.85,127C347.08,127.85,347.84,129.4,347.31,131.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,134.27c-.62,2-2.57,2.76-4.62,2.12-2.81-.87-3.73-3.3-2.69-6.63,1.12-3.6,3.66-4.86,6.53-4a5,5,0,0,1,2.33,1.36l-.71.74a3.84,3.84,0,0,0-1.9-1.14c-2.28-.71-4.2.3-5.09,3.17a6.86,6.86,0,0,0-.22.87,3.54,3.54,0,0,1,3.79-.8C357.47,130.64,358.55,132.33,358,134.27Zm-1.08-.31c.43-1.39-.32-2.6-1.95-3.1a2.56,2.56,0,0,0-3.44,1.46c-.36,1.16.26,2.57,2.09,3.14A2.43,2.43,0,0,0,356.87,134Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,129.88l-.24.77-7.48,8.42-1.17-.36,7.34-8.25-5.44-1.7-.62,2-1.07-.33.92-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.09,134.58l-.24.77-7.47,8.43-1.18-.37,7.34-8.25-5.44-1.69-.61,2-1.08-.34.92-2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,145.45c-.58,1.87-2.53,2.54-5.05,1.76s-3.72-2.44-3.13-4.31a2.75,2.75,0,0,1,2.84-2,2.48,2.48,0,0,1-.93-2.84c.53-1.73,2.33-2.34,4.57-1.65s3.39,2.24,2.86,4a2.53,2.53,0,0,1-2.42,1.8A2.79,2.79,0,0,1,393.12,145.45Zm-1.11-.36c.4-1.3-.46-2.47-2.33-3.05s-3.23-.11-3.64,1.19.44,2.47,2.32,3.05S391.6,146.4,392,145.09Zm-2.07-3.91c1.65.51,2.86.08,3.22-1.07s-.44-2.24-2-2.74-2.84-.08-3.2,1.09S388.3,140.67,389.94,141.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,146.21c-1.12,3.6-3.67,4.86-6.54,4a5.1,5.1,0,0,1-2.33-1.36l.71-.74a4,4,0,0,0,1.9,1.14c2.28.71,4.2-.3,5.1-3.17.07-.24.15-.55.22-.87a3.55,3.55,0,0,1-3.8.8c-2.1-.65-3.18-2.35-2.57-4.28s2.56-2.76,4.62-2.12C404.27,140.45,405.18,142.87,404.15,146.21Zm-.85-2.56c.37-1.16-.26-2.57-2.08-3.14a2.43,2.43,0,0,0-3.3,1.5c-.43,1.38.31,2.59,1.95,3.1A2.55,2.55,0,0,0,403.3,143.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,144.35l-3.29,10.58-1.09-.34,3-9.61-2.49-.77.3-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.36,157.34l-.3,1L416.65,156l.24-.77,5.73-2.94c1.56-.8,2-1.44,2.24-2.17.38-1.22-.25-2.24-1.87-2.74a3.73,3.73,0,0,0-3.25.28l-.56-.91a5,5,0,0,1,4.22-.34c2.14.66,3.16,2.18,2.61,3.94-.32,1-.91,1.82-2.77,2.77l-4.69,2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.49,158.23c-.55,1.76-2.26,2.72-4.81,1.93a5.78,5.78,0,0,1-3.38-2.55l.8-.69a4.83,4.83,0,0,0,2.89,2.24c1.75.55,3,0,3.38-1.28s-.24-2.38-2.2-3l-.75-.23.25-.81,4.07-2.75-5.41-1.69.3-1,6.8,2.11-.24.77L432,154.16C434.26,155,435,156.53,434.49,158.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.15,
    y: 114.95,
    width: 4.81,
    height: 88.68,
    transform: "translate(123.1 485.81) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.92,
    y: 152.13,
    width: 4.81,
    height: 45.48,
    transform: "translate(120.72 513.74) rotate(-72.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.98,
    y: 68.27,
    width: 37.21,
    height: 27.8,
    rx: 4.96,
    transform: "matrix(0.95, 0.3, -0.3, 0.95, 37.78, -84.14)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276,82.56l.53-1.7,18.29,5.69a4,4,0,1,0,2.39-7.65l-18.3-5.7.53-1.7,18.3,5.69a5.8,5.8,0,0,1-3.45,11.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.06,
    y: 79.56,
    width: 1.78,
    height: 13.15,
    transform: "translate(133.23 353.45) rotate(-72.66)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.56,
    y: 56.87,
    width: 95.7,
    height: 8.21,
    transform: "translate(33.38 -97.54) rotate(17.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.73,
    y: 83.09,
    width: 19.26,
    height: 19.26,
    rx: 3.15,
    transform: "translate(47.42 -126.41) rotate(17.29)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.49,
    y: 324.09,
    width: 157.25,
    height: 137.83,
    rx: 8.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.49,414.47H93.77a4,4,0,0,0,4-4H36.65Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 32.28,
    y: 375.21,
    width: 67.84,
    height: 35.77,
    rx: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.13,411a6,6,0,0,0,1.94-.45A5.26,5.26,0,0,0,99,409.06,5,5,0,0,0,100,406c0-5-.05-12.31-.08-21.28,0-1.12,0-2.27,0-3.45a14.41,14.41,0,0,0-.06-1.75,4.66,4.66,0,0,0-.55-1.65,4.78,4.78,0,0,0-2.71-2.23,5.6,5.6,0,0,0-1.84-.23h-2l-16.87,0-38.65,0a4.73,4.73,0,0,0-4,2.27,4.49,4.49,0,0,0-.68,2.27c0,.82,0,1.68,0,2.51q0,5,0,9.86v9.52c0,1.54,0,3.12,0,4.59A4.75,4.75,0,0,0,34.74,410a4.84,4.84,0,0,0,2,.69c.68.07,1.44,0,2.16,0H51.34l14.7,0,21.28.09,5.79,0,1.5,0,.52,0s-.18,0-.52,0l-1.5,0-5.79.05L66,411.16l-14.7,0-8.19,0H38.87c-.74,0-1.43,0-2.21,0a5.1,5.1,0,0,1-2.17-.77,5.22,5.22,0,0,1-2.43-3.87c-.06-1.57,0-3.07,0-4.64,0-3.11,0-6.29,0-9.52v-9.86c0-.84,0-1.67,0-2.53a5.14,5.14,0,0,1,.75-2.52A5.27,5.27,0,0,1,37.27,375l38.65,0,16.87,0h2a6,6,0,0,1,2,.25,5.2,5.2,0,0,1,2.94,2.44,5.1,5.1,0,0,1,.58,1.78,13.91,13.91,0,0,1,.06,1.81c0,1.18,0,2.33,0,3.45,0,9-.07,16.24-.09,21.29a5,5,0,0,1-4.57,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.39,
    cy: 396.97,
    r: 10.04
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 83.39,
    cy: 393.47,
    r: 10.04,
    transform: "translate(-253.8 174.21) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.44,393.47c-.07,0,0-.89-.42-2.43a10,10,0,0,0-3.66-5.4,9.81,9.81,0,0,0-9.31-1.37,9.25,9.25,0,0,0-2.47,1.33,9.13,9.13,0,0,0-2.07,2.09,9.76,9.76,0,0,0,0,11.57,9.91,9.91,0,0,0,4.54,3.42,9.92,9.92,0,0,0,13-6.78,24.3,24.3,0,0,0,.42-2.43,8,8,0,0,1-.22,2.48,9.94,9.94,0,0,1-3.64,5.65,10.09,10.09,0,0,1-4.29,1.95,10.29,10.29,0,0,1-5.4-.42,9.68,9.68,0,0,1-2.61-1.39,9.8,9.8,0,0,1-2.18-2.18,10.22,10.22,0,0,1,0-12.17,9.59,9.59,0,0,1,2.18-2.18,9.71,9.71,0,0,1,2.61-1.4,10.29,10.29,0,0,1,5.4-.41,10.1,10.1,0,0,1,7.93,7.6A8,8,0,0,1,93.44,393.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.7,461.65,204.25,461a29.51,29.51,0,0,1-29.37-29.64L176.31,91.8A29.52,29.52,0,0,1,206,62.41L341.41,63a29.51,29.51,0,0,1,29.37,29.63l-1.43,339.6A29.5,29.5,0,0,1,339.7,461.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,74.76,315,74.64l-76.71-.36-9.23,0-23-.1a20.66,20.66,0,0,0-20.76,20.57l-1.4,331.48a20.66,20.66,0,0,0,20.57,20.75l135.19.62A20.66,20.66,0,0,0,360.39,427l1.4-331.48A20.66,20.66,0,0,0,341.22,74.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,104.88a1.69,1.69,0,1,1-1.68-1.69A1.69,1.69,0,0,1,342.22,104.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.2,111a1.69,1.69,0,1,1-1.69-1.7A1.7,1.7,0,0,1,342.2,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.18,117.05a1.7,1.7,0,1,1-1.69-1.69A1.7,1.7,0,0,1,342.18,117.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.37,
    y: 162.65,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.41,
    y: 156.71,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.84,
    y: 151.78,
    width: 144.1,
    height: 91.42,
    rx: 4.3,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.57,172.66c0,1.17-.93,1.85-2.71,1.85h-3.49v-6.77h3.3c1.69,0,2.56.71,2.56,1.76a1.63,1.63,0,0,1-.9,1.49A1.66,1.66,0,0,1,223.57,172.66Zm-4.65-3.74v1.6h1.56c.76,0,1.18-.27,1.18-.8s-.42-.8-1.18-.8ZM222,172.5c0-.57-.44-.84-1.25-.84h-1.83v1.67h1.83C221.56,173.33,222,173.08,222,172.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,173.06h-3.14l-.6,1.45h-1.61l3-6.77h1.55l3,6.77h-1.64Zm-.49-1.19-1.08-2.59-1.07,2.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,167.74v6.77h-1.29l-3.37-4.11v4.11h-1.55v-6.77h1.3l3.36,4.11v-4.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,171.85l-.91,1v1.71H240v-6.77h1.56v3.16l3-3.16h1.74l-2.8,3,3,3.75h-1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,200.79h-1.24v1.63h-.64v-1.63h-3.5v-.46l3.29-4.12h.71l-3.17,4h2.69v-1.43h.62v1.43h1.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,200.64c0,1-.75,1.84-2.25,1.84a3.23,3.23,0,0,1-2.24-.8l.32-.51a2.69,2.69,0,0,0,1.92.72c1,0,1.6-.48,1.6-1.25s-.53-1.23-1.68-1.23h-.44v-.47l1.72-2.16h-3.18v-.57h4v.46l-1.75,2.21C226.2,199,226.86,199.65,226.86,200.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,200.6c0,1.05-.73,1.88-2.25,1.88a3.22,3.22,0,0,1-2.23-.8l.32-.51a2.64,2.64,0,0,0,1.9.72c1.06,0,1.62-.51,1.62-1.27s-.5-1.29-2.08-1.29h-1.32l.32-3.12h3.4v.57h-2.84l-.22,2h.8C231.17,198.76,231.88,199.5,231.88,200.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,200.57a1.94,1.94,0,0,1-2.12,1.91c-1.65,0-2.55-1.15-2.55-3.11,0-2.11,1.15-3.21,2.84-3.21a2.83,2.83,0,0,1,1.47.34l-.26.51a2.16,2.16,0,0,0-1.2-.29c-1.34,0-2.2.86-2.2,2.55,0,.14,0,.31,0,.5a2,2,0,0,1,1.9-1.06A1.88,1.88,0,0,1,237.36,200.57Zm-.63,0c0-.82-.61-1.34-1.56-1.34a1.44,1.44,0,0,0-1.6,1.35c0,.69.57,1.34,1.64,1.34A1.36,1.36,0,0,0,236.73,200.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,202.42l-1.48-1.95-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L249.63,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.51,202.42,254,200.47l-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.69L254.37,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,202.42l-1.48-1.95-1.49,1.95h-.71l1.84-2.39-1.76-2.27h.71l1.41,1.82,1.4-1.82h.69L259.1,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,202.42l-1.48-1.95L262,202.42h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L263.84,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.34,202.42l-1.48-1.95-1.49,1.95h-.71L279.5,200l-1.75-2.27h.71l1.4,1.82,1.4-1.82H282L280.19,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,202.42l-1.48-1.95-1.49,1.95h-.71l1.85-2.39-1.76-2.27h.71l1.4,1.82,1.4-1.82h.7L284.93,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.81,202.42l-1.48-1.95-1.49,1.95h-.71L289,200l-1.76-2.27h.71l1.4,1.82,1.4-1.82h.69L289.67,200l1.86,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55,202.42l-1.48-1.95-1.49,1.95h-.71l1.84-2.39L292,197.76h.71l1.41,1.82,1.4-1.82h.69L294.4,200l1.87,2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,196.21v6.21h-.64v-5.64h-1.47v-.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.82,200.64c0,1-.75,1.84-2.25,1.84a3.23,3.23,0,0,1-2.24-.8l.32-.51a2.67,2.67,0,0,0,1.92.72c1,0,1.6-.48,1.6-1.25s-.53-1.23-1.68-1.23h-.44v-.47l1.72-2.16h-3.18v-.57h4v.46l-1.75,2.21C315.16,199,315.82,199.65,315.82,200.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,200.79h-1.25v1.63h-.63v-1.63h-3.51v-.46l3.29-4.12h.71l-3.17,4h2.69v-1.43h.62v1.43H322Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,201.86v.56h-4.36V202l2.58-2.53c.7-.69.84-1.11.84-1.53,0-.72-.51-1.16-1.46-1.16a2.08,2.08,0,0,0-1.69.69l-.46-.39a2.8,2.8,0,0,1,2.2-.89c1.26,0,2.06.64,2.06,1.68a2.54,2.54,0,0,1-1,1.94l-2.11,2.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,215.31a1.52,1.52,0,0,1,1.61-1.53,1.54,1.54,0,0,1,1.21.52l-.44.41a.94.94,0,0,0-.74-.35.95.95,0,1,0,0,1.9.94.94,0,0,0,.74-.35l.44.4a1.49,1.49,0,0,1-1.22.53A1.52,1.52,0,0,1,213.73,215.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,216.16h-1.37l-.27.63h-.7l1.32-3h.68l1.32,3h-.71Zm-.21-.52-.47-1.14-.47,1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,216.79l-.58-.82h-.63v.82h-.68v-3h1.28c.79,0,1.29.41,1.29,1.07a1,1,0,0,1-.61.94l.66.95Zm-.65-2.4h-.56v1h.56c.42,0,.63-.19.63-.52S221.87,214.39,221.45,214.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09,216.5l.23-.52a1.7,1.7,0,0,0,1,.31c.41,0,.57-.13.57-.31,0-.56-1.72-.18-1.72-1.28,0-.5.41-.92,1.25-.92a2,2,0,0,1,1,.26l-.21.52a1.76,1.76,0,0,0-.82-.23c-.41,0-.57.15-.57.34,0,.54,1.73.17,1.73,1.25,0,.5-.42.92-1.26.92A2.14,2.14,0,0,1,223.09,216.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,213.83v3h-.69v-1.21h-1.35v1.21h-.68v-3h.68V215h1.35v-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,215.31a1.62,1.62,0,1,1,1.62,1.53A1.53,1.53,0,0,1,230.47,215.31Zm2.55,0a.93.93,0,1,0-.93.95A.91.91,0,0,0,233,215.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,213.83h.69v2.4h1.48v.56h-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,213.83h1.35a1.49,1.49,0,1,1,0,3h-1.35Zm1.32,2.4a.92.92,0,1,0,0-1.84h-.63v1.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.59,216.24v.55H240.3v-3h2.23v.55H241V215h1.37v.54H241v.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,216.79l-.58-.82h-.63v.82h-.68v-3h1.28c.79,0,1.29.41,1.29,1.07a1,1,0,0,1-.61.94l.66.95Zm-.65-2.4h-.56v1h.56c.42,0,.63-.19.63-.52S244.8,214.39,244.38,214.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.05,
    y: 224.16,
    width: 43.95,
    height: 3.8,
    rx: 1.59,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.23,
    y: 224.16,
    width: 24.42,
    height: 3.8,
    rx: 1.59,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.17,151.78H204.62a4.78,4.78,0,0,0-4.78,4.77v24.14c8.5,5.93,20.18,7,30.54,4.81,12.21-2.55,23.27-8.8,34.64-13.92s23.88-9.22,36.17-7.11c11.61,2,21.5,9.21,32,14.56a62.07,62.07,0,0,0,10.76,4.34V156.55A4.78,4.78,0,0,0,339.17,151.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 202.85,
    y: 278.82,
    width: 37.41,
    height: 37.41,
    rx: 8.78,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.25,303.25h-8.18a.47.47,0,0,1-.46-.37l-3-12h-2.84a.49.49,0,0,1,0-1H214a.49.49,0,0,1,.47.37l3,12h7.8a.49.49,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.62,
    cy: 305.56,
    r: 1.53,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,307.57a2,2,0,1,1,2-2A2,2,0,0,1,218.62,307.57Zm0-3.06a1,1,0,1,0,1,1.05A1.06,1.06,0,0,0,218.62,304.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.13,
    cy: 305.56,
    r: 1.53,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.13,307.57a2,2,0,1,1,2-2A2,2,0,0,1,227.13,307.57Zm0-3.06a1,1,0,1,0,1.05,1.05A1,1,0,0,0,227.13,304.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44,301H216.8a.48.48,0,0,1-.49-.48.49.49,0,0,1,.49-.48H228l1.28-7.21H214.63a.48.48,0,1,1,0-1H229.9a.5.5,0,0,1,.37.17.47.47,0,0,1,.1.4l-1.45,8.17A.48.48,0,0,1,228.44,301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.67,
    y: 285.39,
    width: 75.89,
    height: 9.03,
    rx: 3.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.67,
    y: 303.14,
    width: 38.36,
    height: 9.03,
    rx: 3.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.09,264.73c0,.14-39.49.26-88.19.26s-88.21-.12-88.21-.26,39.49-.26,88.21-.26S360.09,264.59,360.09,264.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.31,
    y: 331.22,
    width: 115.04,
    height: 38.79,
    rx: 16.21,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,348.78c0,2-1.46,3.16-3.8,3.16h-1.5v2.24h-2.42v-8.57h3.92C269.1,345.61,270.56,346.83,270.56,348.78Zm-2.44,0c0-.79-.51-1.26-1.51-1.26h-1.35V350h1.35C267.61,350,268.12,349.57,268.12,348.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,352.52h-3.62l-.68,1.66h-2.47l3.78-8.57h2.39l3.79,8.57h-2.52Zm-.71-1.79-1.1-2.74-1.1,2.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,351.11v3.07h-2.42v-3.11l-3.27-5.46h2.56l2,3.41,2-3.41h2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.14,
    cy: 113.69,
    r: 7.47,
    transform: "translate(47.23 287.1) rotate(-76.67)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.92,
    y: 109.85,
    width: 55.94,
    height: 6.55,
    rx: 2.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.39,
    y: 381.2,
    width: 114.19,
    height: 7.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,385c1,.34,14.38.34,14.38,26.75s-.67,59.18,13.37,60.18,87.93,0,87.93,0V405.65a20.09,20.09,0,0,0-20-20.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,385l55.54.17,28.18.1,7.72,0a44.94,44.94,0,0,1,8,.39A20.1,20.1,0,0,1,339.66,395a20.16,20.16,0,0,1,2.89,8.16,36.14,36.14,0,0,1,.18,4.41V412c0,5.94,0,12,0,18.2v42h-.26c-25.84.31-50.41.54-72.75.36-2.79,0-5.54-.07-8.26-.12s-5.39-.07-8.07-.44a9,9,0,0,1-3.62-1.7,13.25,13.25,0,0,1-2.6-2.95,26.44,26.44,0,0,1-3-7,77.27,77.27,0,0,1-2.38-14.17c-.41-4.58-.59-9-.69-13.21-.22-8.43,0-16.05-.15-22.73s-1.16-12.43-3.22-16.65a18.21,18.21,0,0,0-3.58-5.05,13.59,13.59,0,0,0-3.77-2.51,18.51,18.51,0,0,0-3.61-1l.95.15a12.34,12.34,0,0,1,2.7.78,13.67,13.67,0,0,1,3.84,2.5,18.29,18.29,0,0,1,3.65,5.07c2.11,4.24,3.17,10.05,3.33,16.73s0,14.31.23,22.73c.11,4.2.3,8.61.72,13.19a77.67,77.67,0,0,0,2.39,14.08,26.14,26.14,0,0,0,2.94,6.87,12.8,12.8,0,0,0,2.51,2.84,8.81,8.81,0,0,0,3.43,1.61c2.56.34,5.29.32,8,.41s5.47.1,8.26.12c22.32.15,46.9-.1,72.74-.41l-.26.26V430.18c0-6.18,0-12.26,0-18.2v-4.44a34.72,34.72,0,0,0-.16-4.35,19.78,19.78,0,0,0-15.93-17,45.31,45.31,0,0,0-7.88-.4l-7.69-.05-28-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,471.94s11.56,0,14-17.05c2.95-20.32,0-38.12,15.71-38.79s57.84,0,57.84,0v55.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,416.3s12.67-1.53,12.67,19.53.33,35,14.37,36.55,100.31,0,100.31,0-13.71-6.46-14.71-25.52-5-30.68-18.73-31.05S282.67,416.3,282.67,416.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,416.3l.85,0,2.49,0,9.61-.15,35.35-.38,24.44-.17,13.63,0c2.34,0,4.72,0,7.13.07a20.28,20.28,0,0,1,7.24,1.39,14.66,14.66,0,0,1,5.88,4.72,24.5,24.5,0,0,1,3.47,6.91,68,68,0,0,1,2.63,15.66c.09,1.35.16,2.7.31,4l.2,2,.38,2,.18,1,.28,1,.56,2a35,35,0,0,0,1.59,3.8,27.49,27.49,0,0,0,11.24,12.08l.87.48-1,0-2.39,0c-23.15.38-45.2.63-65.26.62-10,0-19.57,0-28.49-.42a40.64,40.64,0,0,1-6.56-.71,13.29,13.29,0,0,1-5.69-2.87,13.94,13.94,0,0,1-3.52-5,26.43,26.43,0,0,1-1.69-5.6,69.41,69.41,0,0,1-1.08-10.78c-.13-3.42-.14-6.64-.14-9.66,0-1.5,0-3-.07-4.35,0-.7,0-1.38-.1-2.05s-.16-1.32-.24-1.95l-.12-.95c-.06-.31-.13-.61-.2-.91-.13-.6-.27-1.19-.39-1.76l-.56-1.62-.27-.77-.36-.72a12.19,12.19,0,0,0-3.32-4.45,9.79,9.79,0,0,0-3.56-2,9.53,9.53,0,0,0-2.48-.45c-.29,0-.5,0-.65,0h-.21a1.92,1.92,0,0,1,.21,0,5.66,5.66,0,0,1,.65,0,9.42,9.42,0,0,1,2.51.41,9.71,9.71,0,0,1,3.63,1.95,12.38,12.38,0,0,1,3.41,4.48c2,3.83,2.43,9.18,2.41,15.17,0,3,0,6.24.18,9.65a71.1,71.1,0,0,0,1.11,10.72,26.13,26.13,0,0,0,1.68,5.52A13.55,13.55,0,0,0,301.9,469a12.69,12.69,0,0,0,5.52,2.76,39,39,0,0,0,6.48.68c8.91.37,18.44.38,28.47.38,20.05,0,42.1-.29,65.25-.66l2.39-.05-.11.5a28,28,0,0,1-11.48-12.32,36.28,36.28,0,0,1-1.61-3.87l-.57-2-.28-1-.19-1-.38-2-.2-2c-.15-1.37-.22-2.71-.31-4a67.24,67.24,0,0,0-2.6-15.55A23.93,23.93,0,0,0,388.9,422a14.17,14.17,0,0,0-5.68-4.58,20,20,0,0,0-7.06-1.37c-2.41,0-4.78-.06-7.12-.08H355.41l-24.44.1-35.35.22-9.61.05h-2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,416.27c0,.06-1,0-2.8.21a12.11,12.11,0,0,0-6.73,3.27c-2.35,2.19-4.11,5.78-5,9.93s-1,8.92-1.17,13.87a68.84,68.84,0,0,1-1.62,13.91,32.86,32.86,0,0,1-2.07,5.77,21.26,21.26,0,0,1-2.73,4.6,11.51,11.51,0,0,1-3.37,2.85,11.9,11.9,0,0,1-3.16,1.09,12.89,12.89,0,0,1-2.09.19,4.07,4.07,0,0,1-.73,0,3.54,3.54,0,0,1,.73-.09,13.54,13.54,0,0,0,2-.28,11.69,11.69,0,0,0,3.05-1.15,11.07,11.07,0,0,0,3.24-2.83,21.57,21.57,0,0,0,2.62-4.54,34.46,34.46,0,0,0,2-5.71,70.57,70.57,0,0,0,1.56-13.82c.21-4.93.28-9.7,1.22-13.94s2.75-7.87,5.21-10.1a12,12,0,0,1,6.95-3.2,9.33,9.33,0,0,1,1.21-.09,8.39,8.39,0,0,1,.89,0A3.81,3.81,0,0,1,286,416.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.08,400.32c0,.14-16.2.26-36.18.26s-36.18-.12-36.18-.26,16.19-.26,36.18-.26S328.08,400.17,328.08,400.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,411.08c0,.14-15.67.26-35,.26s-35-.12-35-.26,15.66-.26,35-.26S329.58,410.94,329.58,411.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.91,432c0,.15-16.2.26-36.18.26s-36.18-.11-36.18-.26,16.2-.26,36.18-.26S378.91,431.87,378.91,432Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.81,444.57c0,.14-14.86.26-33.19.26s-33.19-.12-33.19-.26,14.86-.26,33.19-.26S379.81,444.43,379.81,444.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.15,
    y: 164.45,
    width: 13.34,
    height: 13.34,
    rx: 3.15,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.85,149.81l-6.61-.8a25.41,25.41,0,1,1,6.54-6.33h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85,149.81s0-.17,0-.49,0-.78,0-1.38c0-1.22-.06-3-.1-5.27l.15.07h0a.09.09,0,0,1-.13,0,.11.11,0,0,1,0-.12,25.16,25.16,0,0,0,4.45-11.3,25.6,25.6,0,0,0-.21-8,25.34,25.34,0,0,0-3.27-8.47,25.81,25.81,0,0,0-6.85-7.33,24.59,24.59,0,0,0-9.94-4.29,25.66,25.66,0,0,0-11.5.49,24.65,24.65,0,0,0-10.48,6,25.36,25.36,0,0,0-4,4.77c-.51.89-1,1.77-1.48,2.68l-.6,1.4-.29.69-.23.72a25.82,25.82,0,0,0-1,11.58,24.58,24.58,0,0,0,3.92,10.21,25.28,25.28,0,0,0,15.52,10.78l2.1.36c.69.11,1.38.12,2,.19a22.65,22.65,0,0,0,3.88-.08,25.28,25.28,0,0,0,11.42-4h.06l4.87.64,1.28.18.45.07-.42,0-1.26-.13-4.94-.54.06,0a25.23,25.23,0,0,1-11.49,4.19,22.17,22.17,0,0,1-3.93.1c-.68-.06-1.37-.07-2.07-.17l-2.13-.36a25.58,25.58,0,0,1-8.54-3.62A26.26,26.26,0,0,1,30.87,142a24.91,24.91,0,0,1-4-10.37,26.15,26.15,0,0,1,1-11.79l.23-.73.3-.71c.21-.47.41-1,.61-1.42.45-.94,1-1.83,1.5-2.74a26.28,26.28,0,0,1,4-4.86,25,25,0,0,1,10.66-6.06A26,26,0,0,1,57,102.79a24.83,24.83,0,0,1,10.1,4.39A26,26,0,0,1,74,114.64a25.52,25.52,0,0,1,3.29,8.61,26.18,26.18,0,0,1,.17,8.11,25.28,25.28,0,0,1-4.59,11.37l-.14-.12h0a.09.09,0,0,1,.13,0,.07.07,0,0,1,0,.06V148c0,.58,0,1,0,1.36S72.85,149.81,72.85,149.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.97 129.45 44.14 126.05 50.68 131.48 62.73 119.07 65.89 122.25 50.43 137.84 40.97 129.45",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.91,117.45a19.19,19.19,0,0,1,20.36-16.21l1,.07c10.64,1.4,15.39,11.23,13.7,21.83l-3.71,37.62-.18,7.77-25.35,2.3.55-16.42s-10.16-2.34-9.54-12.62C94,136.82,95.49,126.64,96.91,117.45Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,154.39a24.9,24.9,0,0,0,13.75-3s-3.57,7.42-13.75,5.75Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,127.7a1.47,1.47,0,0,0,1.31,1.58,1.42,1.42,0,0,0,1.61-1.21,1.47,1.47,0,0,0-1.31-1.59A1.42,1.42,0,0,0,100.89,127.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,122.64c.17.2,1.34-.54,2.92-.42s2.68,1,2.86.81-.07-.44-.54-.84a4.07,4.07,0,0,0-2.28-.89,4,4,0,0,0-2.34.57C98.86,122.21,98.67,122.55,98.75,122.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,129.11a1.46,1.46,0,0,0,1.3,1.58,1.4,1.4,0,0,0,1.61-1.21,1.48,1.48,0,0,0-1.3-1.59A1.4,1.4,0,0,0,115.69,129.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,124.06c.17.21,1.34-.53,2.92-.42s2.68,1,2.86.82-.07-.44-.55-.85a4,4,0,0,0-2.27-.88,3.83,3.83,0,0,0-2.34.57C114.36,123.64,114.17,124,114.25,124.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.67,135.35a10.62,10.62,0,0,0-2.53-.65c-.4-.07-.78-.18-.83-.46a2.09,2.09,0,0,1,.36-1.17l1.42-3c2-4.25,3.43-7.76,3.26-7.84s-1.91,3.31-3.89,7.56c-.47,1-.93,2-1.36,3a2.34,2.34,0,0,0-.33,1.57,1,1,0,0,0,.62.63,2.8,2.8,0,0,0,.68.15A10.31,10.31,0,0,0,107.67,135.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,136.78c-.25,0-.38,1.68-1.93,2.79s-3.37.79-3.4,1,.38.36,1.15.44a4.28,4.28,0,0,0,2.83-.76,3.71,3.71,0,0,0,1.51-2.35C112.51,137.22,112.35,136.78,112.23,136.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29,117.85c.13.44,1.72.35,3.55.71s3.3,1,3.58.6c.12-.18-.11-.6-.69-1.06a6.33,6.33,0,0,0-5.42-1C114.61,117.32,114.24,117.64,114.29,117.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.67,118.11c.25.38,1.36.09,2.67.16s2.4.42,2.68.06c.13-.17,0-.54-.48-.92a3.92,3.92,0,0,0-4.32-.18C99.74,117.57,99.56,117.93,99.67,118.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.59,133a2.78,2.78,0,0,1,3.2-2.46c1.91.32,4,1.56,3.54,5.51-.73,7-7.62,4.82-7.61,4.62S129.25,135.94,129.59,133Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.53,138.2s.11.1.31.22a1.23,1.23,0,0,0,.91.11,3,3,0,0,0,1.68-2.56,4.16,4.16,0,0,0-.16-1.78,1.42,1.42,0,0,0-.82-1,.64.64,0,0,0-.76.26c-.11.19-.08.33-.12.34s-.14-.13,0-.41a.72.72,0,0,1,.32-.41.91.91,0,0,1,.7-.11A1.72,1.72,0,0,1,133.7,134a4.11,4.11,0,0,1,.21,2c-.19,1.4-1,2.65-2.09,2.83a1.29,1.29,0,0,1-1.1-.3C130.52,138.38,130.5,138.22,130.53,138.2Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2,125.87c-.58,2-.37,5.35-2.16,4.89-3.57-.9-2.71,6.41-4.42,5.69s-3.18-2.78-3.29-7.28c-.13-5.7,2.16-9.82-.08-16.36a8.65,8.65,0,0,0-7.22-4.47,8.8,8.8,0,0,0-7.57,4c-.32-2-1.29-5-3.06-6a5.16,5.16,0,0,0-5.67.47,4.19,4.19,0,0,0-.74,5.45,2,2,0,0,1-2.24-.8,3.36,3.36,0,0,0,.89,2.56,3.11,3.11,0,0,1-1.81-1.26c.18.83.35,1.65.53,2.47-3,.08-5.94-2.83-6.78-5.41-1.26-3.93-.29-7.89,1.91-11.38a12.33,12.33,0,0,1,10.24-5.91c4.12,0,7.57,2,9.16,5.79,2.68-1.89,8.1-2.55,11.08-1.19a9.63,9.63,0,0,1,5.49,7.63,5.74,5.74,0,0,1,5.68,1.1l.38.33a8.58,8.58,0,0,1,2.49,7.9c-.22,1.15-.62,2.33-.85,3.25C136.47,120.11,135.2,125.87,135.2,125.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,111.32s-.09,0-.24-.19a4.38,4.38,0,0,1-.59-.64,6,6,0,0,1-1.18-3,5.7,5.7,0,0,1,1.4-4.49,6.14,6.14,0,0,1,5.36-2,6.89,6.89,0,0,1,2.84,1.12A9.21,9.21,0,0,1,108,104a11.17,11.17,0,0,1,2.5,7.45c0,.38,0,.67-.09.87a1.21,1.21,0,0,1-.06.3,13.41,13.41,0,0,0-.41-4.31,11.29,11.29,0,0,0-2.16-4.13,7.84,7.84,0,0,0-4.76-2.9,5.91,5.91,0,0,0-5.11,1.91,5.53,5.53,0,0,0-1.39,4.28,6.08,6.08,0,0,0,1.06,2.93C98,111,98.3,111.3,98.28,111.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,114.46a1.67,1.67,0,0,1-.21-.34c-.13-.23-.32-.57-.55-1a22.66,22.66,0,0,1-1.65-3.92,11.16,11.16,0,0,1-.46-2.91,8,8,0,0,1,.61-3.33,6.52,6.52,0,0,1,2.41-2.87,7.88,7.88,0,0,1,3.81-1.26,9.72,9.72,0,0,1,4,.63,12.58,12.58,0,0,1,3.25,1.86,9.64,9.64,0,0,1,3.55,5.14,7,7,0,0,1-.21,4.22,5.06,5.06,0,0,1-.52,1,1.34,1.34,0,0,1-.25.32,8.22,8.22,0,0,0,.66-1.39,7.09,7.09,0,0,0,.11-4.12,9.58,9.58,0,0,0-3.52-5,10.7,10.7,0,0,0-7-2.4,7.59,7.59,0,0,0-3.67,1.21,6.29,6.29,0,0,0-2.31,2.72,7.9,7.9,0,0,0-.61,3.22,10.88,10.88,0,0,0,.41,2.85,23.68,23.68,0,0,0,1.55,3.92l.5,1A1.89,1.89,0,0,1,96.9,114.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.72,121.33s.65-.53,1.51-1.54a10.6,10.6,0,0,0,2.24-4.58,10.44,10.44,0,0,0-.24-5.09c-.38-1.27-.81-2-.76-2a2,2,0,0,1,.33.48,9.47,9.47,0,0,1,.64,1.46,9.89,9.89,0,0,1-2.05,9.88,9.46,9.46,0,0,1-1.17,1.09A1.92,1.92,0,0,1,132.72,121.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33,121.13s.35-.16.91-.54a5.11,5.11,0,0,0,1.77-2.13l.29-.67-.06.73c-.09,1-.19,2.13-.3,3.36l-.23-.14a9.2,9.2,0,0,0,3.86-5.94,9.54,9.54,0,0,0,0-3.3,13.21,13.21,0,0,0-1-2.9s.05.05.13.17a5,5,0,0,1,.31.54,8.73,8.73,0,0,1,.77,2.15,9.22,9.22,0,0,1-3.9,9.53l-.26.17,0-.31c.13-1.23.25-2.37.36-3.35l.23.06a5.1,5.1,0,0,1-1.92,2.15,5.59,5.59,0,0,1-.71.35A.75.75,0,0,1,126.33,121.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,106.35a6.65,6.65,0,0,0-1.62-2,5.89,5.89,0,0,0-2.53-1.17,6.19,6.19,0,0,0-3.37.3,7.25,7.25,0,0,0-2.83,1.92,8.69,8.69,0,0,0-1.53,2.37,16.38,16.38,0,0,0-.76,2.51,2.25,2.25,0,0,1,.05-.71,8.9,8.9,0,0,1,.51-1.89,8.6,8.6,0,0,1,1.51-2.48,7.4,7.4,0,0,1,2.94-2,6.41,6.41,0,0,1,3.54-.29,5.92,5.92,0,0,1,2.61,1.28,5.3,5.3,0,0,1,1.23,1.53,4.71,4.71,0,0,1,.21.49C124.38,106.28,124.39,106.34,124.38,106.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.74,101a9.8,9.8,0,0,0-1.93-.75,7.08,7.08,0,0,0-4.82.68,8.75,8.75,0,0,0-3.41,3.55c-.61,1.14-.81,1.93-.86,1.91a1.75,1.75,0,0,1,.1-.56,8.71,8.71,0,0,1,.56-1.45,8.51,8.51,0,0,1,3.46-3.72,6.92,6.92,0,0,1,5-.62,5.37,5.37,0,0,1,1.43.61A1.79,1.79,0,0,1,122.74,101Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,432.13l.71,19.23s-19.31,7.18-19.53,10.75l37.34,0,.13-30Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.42,449.74a1.52,1.52,0,0,1,1.06,1.74,1.47,1.47,0,0,1-1.72,1.06,1.61,1.61,0,0,1-1.1-1.85,1.51,1.51,0,0,1,1.9-.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,462.08l-.1-3-35.76,1.16s-1.67.73-1.48,1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,451.18c0,.18.92.26,1.82.84s1.37,1.36,1.54,1.28-.1-1.12-1.2-1.81S100.23,451,100.27,451.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.36,452.8c0,.18.75.48,1.37,1.26s.8,1.58,1,1.57.29-1-.49-2S96.36,452.62,96.36,452.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14,457.49c.16,0,.42-.88,0-1.87s-1.32-1.4-1.4-1.25.45.69.82,1.51S94,457.47,94.14,457.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,446.77c.08.17.91-.08,1.94,0s1.84.39,1.93.23-.68-.8-1.89-.87S100.51,446.63,100.6,446.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,433.89l1.48,23.24-4.12,18.72a2.39,2.39,0,0,0,2,2.87h0a2.36,2.36,0,0,0,2.06-.7c3.41-3.55,15.9-16.68,15.69-18.37-.23-2,.06-24.61.06-24.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.36,478.72l17.69-20.64,0,1a3.59,3.59,0,0,1-.76,2.36c-1.4,1.79-5.39,6.67-14.84,16.59a2.38,2.38,0,0,1-2.13.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,450.77a1.43,1.43,0,0,0-.32,1.9,1.39,1.39,0,0,0,1.88.33,1.52,1.52,0,0,0,.32-2,1.43,1.43,0,0,0-2-.13",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.26,468.34a7.38,7.38,0,0,0-2.12-1.73,7.19,7.19,0,0,0-2.7-.4c0-.06.27-.25.81-.35a3.77,3.77,0,0,1,3.72,1.65C147.26,468,147.31,468.31,147.26,468.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,471.52a20,20,0,0,0-2.1-.92,22.44,22.44,0,0,0-2.29-.2,2.68,2.68,0,0,1,2.41-.29C145.14,470.45,145.85,471.45,145.73,471.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,464.22a24.08,24.08,0,0,0-3.15-1.64,25.05,25.05,0,0,0-3.48-.66,6.51,6.51,0,0,1,6.63,2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.32,457.12c-.06.14-1.37-.35-3-.34s-3,.47-3,.32a5.92,5.92,0,0,1,6.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.05,450.28a12,12,0,0,0-3.15-.43,11.94,11.94,0,0,0-3.05.9s.2-.35.72-.68a5.24,5.24,0,0,1,2.29-.73,5.1,5.1,0,0,1,2.37.38C149.8,450,150.08,450.23,150.05,450.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,448.55a1.94,1.94,0,0,1-.07-.88,6.26,6.26,0,0,1,.6-2.33,2.78,2.78,0,0,1,1.11-1.34,1,1,0,0,1,1.09.17,1.49,1.49,0,0,1,.41,1,3.37,3.37,0,0,1-2.82,3.24,3.93,3.93,0,0,1-3.93-1.89,1.39,1.39,0,0,1-.11-1.12,1,1,0,0,1,1-.54,3.29,3.29,0,0,1,1.56.73,6.82,6.82,0,0,1,1.66,1.75c.32.47.42.77.39.78a10.73,10.73,0,0,0-2.26-2.23,3.07,3.07,0,0,0-1.38-.61.5.5,0,0,0-.52.29,1,1,0,0,0,.11.74,3.49,3.49,0,0,0,3.42,1.59,2.92,2.92,0,0,0,2.44-2.71,1.11,1.11,0,0,0-.26-.73.5.5,0,0,0-.59-.11,2.45,2.45,0,0,0-1,1.12A9,9,0,0,0,146.89,448.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.81,269.59a82.66,82.66,0,0,0-2.36,24.26c.27,5.18,16.9,154.7,16.9,154.7l21.14-1.9-3.65-139.8.88.79s12.6,58.82,13.44,68.12c.75,8.35,10.8,75.49,10.8,75.49l20.52-1-4.65-84.88-6.22-77-2.49-22.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91,294.8a5,5,0,0,1-1,.53,11.34,11.34,0,0,1-2.94.95,6.36,6.36,0,0,1-2.17,0,4.57,4.57,0,0,1-2.24-1.14,5.53,5.53,0,0,1-1.32-2.44c-.25-.92-.39-1.88-.56-2.85-.66-3.89-1.09-7.44-1.33-10-.12-1.28-.19-2.33-.23-3.05a4.75,4.75,0,0,1,0-1.13,5.57,5.57,0,0,1,.2,1.11c.1.82.23,1.84.38,3,.33,2.57.81,6.1,1.47,10,.33,1.92.55,3.87,1.72,5a4.86,4.86,0,0,0,4,1.15,13.8,13.8,0,0,0,2.92-.78A4.49,4.49,0,0,1,119.91,294.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,276.42s.16-.12.49-.14a2.18,2.18,0,0,1,1.31.46,2.36,2.36,0,0,1,.95,1.84,2.34,2.34,0,0,1-4,1.4,2.35,2.35,0,0,1-.4-2,2,2,0,0,1,.74-1.17c.27-.2.45-.22.46-.2a2.62,2.62,0,0,0-.86,1.44,2,2,0,0,0,.41,1.66,1.75,1.75,0,0,0,1.94.41,1.78,1.78,0,0,0,1.26-1.52,2.08,2.08,0,0,0-.72-1.56A2.67,2.67,0,0,0,113.24,276.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.32,287a2.72,2.72,0,0,1-.81.1,15,15,0,0,1-2.21,0,21.42,21.42,0,0,1-13.08-5.87,15.28,15.28,0,0,1-1.49-1.64c-.32-.41-.48-.65-.45-.67s.8.83,2.18,2.05a23.73,23.73,0,0,0,12.88,5.78C149.16,286.91,150.31,286.88,150.32,287Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,276.39A10.35,10.35,0,0,1,92,278.76a26.89,26.89,0,0,1-4.2,5,26.54,26.54,0,0,1-5.27,3.82,10.17,10.17,0,0,1-2.46,1.1,25.16,25.16,0,0,1,2.28-1.4,34.47,34.47,0,0,0,5.11-3.88,34,34,0,0,0,4.25-4.81A23.1,23.1,0,0,1,93.32,276.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.33,191.93c-3.14,9.17-2.79,8.38-8.67,35.78-1.08,5.06.83,13,5.39,15.4s12.66-.24,15.37-4.64l4.36-41.35Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,241.62,148,219.83l.09-2.14,22.11-5.16s-4.34-14.3-8.32-29.67c-2.3-8.88-9.95-13.34-11.8-14.3h0l-.41-.19h0l-21.28-9c-4.3,4.58-10.56,8.26-16.59,6.5a18.89,18.89,0,0,1-8.76-6L88.71,164.8h0a18.68,18.68,0,0,0-9.92,8C75.79,178.15,66.2,202.5,66,203l17.76,1.59s-3.15,57.62-2,67.91c0,0,4.32,3,15.2,3.5,22.08,1,54.93-.53,54.93-.53-.52-3.32-1.06-8.87-1.36-11.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,183.18c.09,0-.38,13.74-1.05,30.68S82.06,244.54,82,244.54s.38-13.74,1-30.69S84.31,183.17,84.4,183.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.7,187c-.15,0,.29,12.2,1,27.23s1.41,27.21,1.57,27.2-.29-12.19-1-27.23S145.86,187,145.7,187Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.31,222.9c-.72-5.41-1.32-10.19-1.32-10.19l-17.68,4.11.76,2.85L138.4,205.78l-2.17.19-6.88,7.15s6,12.67,9.49,17.6c4.54,6.42,11.67,16.2,21.44,15.38C169.31,245.34,171.6,232.6,170.31,222.9Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.73,226.14a15,15,0,0,0-3.88-3.57,15.71,15.71,0,0,0-4.62-2.56c-.08.15,2,1.33,4.28,3S160.62,226.26,160.73,226.14Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,187.66l6.08-3.1,7.88,2.5,3.9,3.6,6,15.12,4.81,6.09-8.49,11-5.37-9.8s-4.55-2-6.38-4.86-2.64-4.44-2.64-4.44-2.63-1.26-3.12-2.48a5.82,5.82,0,0,1-.46-2.15l1.33-1.95a4.9,4.9,0,0,1,.4-2.48,2.43,2.43,0,0,1,1-.83s-.39-1.64.22-2.23a19.33,19.33,0,0,1,3.64-1.66h0l-2.65-1.51S114.86,190.35,114.53,187.66Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,193.15c0,.08-.93.1-2,.34s-2,.58-2,.51a4.78,4.78,0,0,1,2-.76A4.53,4.53,0,0,1,123.55,193.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,196.54a16,16,0,0,1-1.76.23,14.79,14.79,0,0,1-1.74.3,3.83,3.83,0,0,1,1.7-.56A4,4,0,0,1,121.73,196.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,201.86c-.07,0-.12-.35-.11-.78s.07-.77.14-.77.12.35.12.78S119.23,201.86,119.16,201.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,203.5a3.4,3.4,0,0,0-.56-1.4,3.79,3.79,0,0,0-1.22-.89s.19-.05.48,0a2,2,0,0,1,1,.68,2.08,2.08,0,0,1,.43,1.08C120.42,203.32,120.35,203.5,120.32,203.5Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07,198.65a3.7,3.7,0,0,0-1.06-1,4,4,0,0,0-1.44-.36s.16-.11.46-.13a2.08,2.08,0,0,1,1.92,1.07C125.09,198.46,125.1,198.64,125.07,198.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,195.29c-.07,0-.31-.6-1-1a4.66,4.66,0,0,0-1.33-.46s.16-.09.44-.09a2.12,2.12,0,0,1,1,.33,2,2,0,0,1,.73.79C127.86,195.11,127.87,195.28,127.84,195.29Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,193.64s0-.21-.07-.52a2.38,2.38,0,0,0-.44-1.11,2.41,2.41,0,0,0-.94-.75c-.29-.13-.49-.17-.48-.21s.22-.06.54,0a2.1,2.1,0,0,1,1.09.76,2.15,2.15,0,0,1,.41,1.26C129.81,193.45,129.73,193.65,129.7,193.64Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12,189.69c0,.09-1.27.11-2.8.34s-2.69.78-2.73.71a6.31,6.31,0,0,1,2.69-1,12.18,12.18,0,0,1,2-.15A2.41,2.41,0,0,1,127.12,189.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.82,223.83a10.78,10.78,0,0,0-1.5-5c-1.78-2.51-5.27-3-8.33-2.89s-6.26.75-9.14-.3l-8.62,25.58A12.79,12.79,0,0,0,90,235.53c.88-1.43,1.52-3.09,2.85-4.11,1.84-1.41,4.38-1.21,6.7-1.23a27,27,0,0,0,7.15-1.05,4.77,4.77,0,0,0,2.63-1.5C110.12,226.58,110,225.14,109.82,223.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M87.63,193.89l2.68,28.47a4,4,0,0,0,1.76,3.27l17.27-.36a6.87,6.87,0,0,0,1.32-4.84l-1.92-27.25c-.11-1.64-.72-2.82-1.46-2.84l-18.19-.42C88.16,189.9,87.44,191.86,87.63,193.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.12,199.61a2.49,2.49,0,0,1,.06-3.08,3.82,3.82,0,0,1,3-1.32,8.38,8.38,0,0,1,3.24.75A21.14,21.14,0,0,1,95,197.89a3.49,3.49,0,0,1,1.79,2.19c.14,1-.93,2-1.76,1.53a4.09,4.09,0,0,1,2.32,2.9c.15,1.21-.52,1.85-1.7,2.17a1.84,1.84,0,0,1,1,2.37,2.1,2.1,0,0,1-2.65.74,6.09,6.09,0,0,1-2.25-2,6.91,6.91,0,0,1,.31,4.34c-2.58-1-5.12-3.81-4.35-6.53a3.69,3.69,0,0,1-1-4.41,3.61,3.61,0,0,1-2.08-3.07",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84,197.13l-.21,12.17-3.16,4.75L67,227s2.14,17.59,8.68,15.67,8.11-3.17,12-10.26c2.06-3.81,3.34-10,4.53-13.53.7-2.08.09-8.78.09-8.78Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.65,206.7a9.23,9.23,0,0,1-1.11-.89,7.56,7.56,0,0,0-2.92-1.58,4.08,4.08,0,0,0-1.8,0,3.3,3.3,0,0,0-1.33.63,4.34,4.34,0,0,0-.88,1.05s0-.14.11-.37a2.58,2.58,0,0,1,.64-.84,3.37,3.37,0,0,1,1.4-.73,4.16,4.16,0,0,1,1.92,0,7,7,0,0,1,3,1.71A5.58,5.58,0,0,1,95.65,206.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.47,201.74a6,6,0,0,1-1.35-.6c-.4-.2-.88-.45-1.43-.67a12.47,12.47,0,0,0-1.86-.52,5.6,5.6,0,0,0-1.9-.07,3.51,3.51,0,0,0-1.41.58,3.63,3.63,0,0,0-1,1.07,1,1,0,0,1,.12-.38,2.59,2.59,0,0,1,.7-.85,3.41,3.41,0,0,1,1.5-.67,5.16,5.16,0,0,1,2,0,10.63,10.63,0,0,1,1.9.56,12.73,12.73,0,0,1,1.44.73A11.32,11.32,0,0,1,95.47,201.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.56,234a11.63,11.63,0,0,1-.18-4.53,13.72,13.72,0,0,1,1.71-4.61,22.45,22.45,0,0,1,3.82-4.68c1.56-1.51,3.16-2.82,4.59-4a49.29,49.29,0,0,0,3.66-3.45A21.83,21.83,0,0,0,84.27,210a5.57,5.57,0,0,0,.6-1.09,8.62,8.62,0,0,0-.75,1,26.06,26.06,0,0,1-2.21,2.53c-1,1-2.25,2.14-3.7,3.35s-3,2.52-4.63,4a21.81,21.81,0,0,0-3.87,4.81A13.57,13.57,0,0,0,68,229.4a9.47,9.47,0,0,0,.12,3.4,6.42,6.42,0,0,0,.26.89C68.5,233.89,68.54,234,68.56,234Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOrderAlHalal);
export default __webpack_public_path__ + "static/media/placeOrderAlHalal.1130a077791f5296cb183e725e5cc930.svg";
export { ForwardRef as ReactComponent };